/* eslint-disable */
export default {
  title: 'Audio',
  input: 'Input',
  microphone: 'Microphone',
  autoAdjustMicLevel: 'Automatically adjust my mic level',
  output: 'Output',
  speakerSource: 'Speaker source',
  speakerVolume: 'Speaker volume',
  ringtoneSource: 'Ring tone and notification source',
  ringtoneVolume: 'Ring tone and notification volume',
  ringtones: 'Ring tones',
  noDevices: 'No devices',
  off: 'Off',
  noLabel: 'Unknown device',
  stopRecordDescription:
    'Say something to check your mic level ({countDown} sec)',
  stopPlaybackDescription: 'Playing your recording...',
  startRecordButton: 'Test microphone',
  stopRecordButton: 'Stop recording',
  stopPlaybackButton: 'Stop test',
  startTestButton: 'Test speaker',
  stopTestDescription: 'Playing sample sound...',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"input"@#@ @source: @#@"Input"@#@
// @key: @#@"microphone"@#@ @source: @#@"Microphone"@#@
// @key: @#@"autoAdjustMicLevel"@#@ @source: @#@"Automatically adjust my mic level"@#@
// @key: @#@"output"@#@ @source: @#@"Output"@#@
// @key: @#@"speakerSource"@#@ @source: @#@"Speaker source"@#@
// @key: @#@"speakerVolume"@#@ @source: @#@"Speaker volume"@#@
// @key: @#@"ringtoneSource"@#@ @source: @#@"Ringtone and notification source"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone and notification volume"@#@
// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"noDevices"@#@ @source: @#@"No devices"@#@
// @key: @#@"off"@#@ @source: @#@"Off"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"stopRecordDescription"@#@ @source: @#@"Say something to check your mic level ({countDown} sec)"@#@
// @key: @#@"stopPlaybackDescription"@#@ @source: @#@"Playing your recording..."@#@
// @key: @#@"startRecordButton"@#@ @source: @#@"Test microphone"@#@
// @key: @#@"stopRecordButton"@#@ @source: @#@"Stop recording"@#@
// @key: @#@"stopPlaybackButton"@#@ @source: @#@"Stop test"@#@
// @key: @#@"startTestButton"@#@ @source: @#@"Test speaker"@#@
// @key: @#@"stopTestDescription"@#@ @source: @#@"Playing sample sound..."@#@
